// src/app/shared/role-display-name.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { ROLE_DISPLAY_NAMES, RoleType } from './system-roles';

@Pipe({ name: 'roleDisplayName', standalone: true })
export class RoleDisplayNamePipe implements PipeTransform {
  transform(role: string | undefined | null): string {
    if (!role) return '';
    return ROLE_DISPLAY_NAMES[role as RoleType] ?? role;
  }
}